/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import {updateCategory,setQuote,initQuote,uploadProducts,setLoading,setQuoteLoading, setCompanyLoaded} from '../../actions/quote'
import Category from "../Category.js"
import {supplier_arry} from "../../config"
import { getDateTime } from "../../common"
import { toast } from 'react-toastify';
import OrderHeader from "../IndexSections/OrderHeader.js";
import { Badge } from "reactstrap";
import { API_URL, downloadFile, APP_URL } from"../../network"
import Memo from "../IndexSections/Memo"
import { Editor } from '@tinymce/tinymce-react';

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";
import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import Product from "../IndexSections/Product.js";
import { ReactNotifications, Store } from 'react-notifications-component'



function Index(props) {
  const [discount, setDiscount] = useState(0);
  const [approvedPrice, setApprovedPrice] = useState(0);
  const main = useRef();
  const [modal, setModal] = useState(false);
  const [noteModal, setNoteModal] = useState(false);
  // const [logoImage, setLogoImage] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [emailaddress, setEmailaddress] = useState("");
  const [emailnote, setEmailnote] = useState("");
  const [memoNote, setMemoNote] = useState("");
  const [newMemoNote, setNewMemoNote] = useState("");
  const [memos, setMemos] = useState([]);
  
  const logoRef = useRef(null);

  const toggle = () => setModal(!modal);
  const toggleNote = () => setNoteModal(!noteModal);
  useEffect(() => {
    props.initQuote()
    let { id } = props.match.params
    props.setQuoteLoading(true)
    axios.get(`/quotes/edit/${id}`).then(res => {
      console.log('res.data',res.data)
      if(res.data.status == "success"){
        var quote = res.data.data
        // if(quote && quote.contact_user == null){
        //   alert("Please select contact first");
        // }

        if(quote && quote.content){
          var categories = JSON.parse(quote.content);
          for(var key in categories){
            var category = {...categories[key]};
            var items = category['items']
            var groups = category['groups']
            for(var loop = 0; loop < items.length; loop++){
              if(groups){
                var group = groups[loop]
                if("fee_price" in group){
                  group['fee_price'] = (group['fee_price']*1).toFixed(2)
                }
                else{
                  group['fee_price'] = (0).toFixed(2)
                }
                if("price" in group){
                  group['price'] = (group['price']*1).toFixed(2)
                }
                else{
                  group['price'] = (0).toFixed(2)
                }
                if("discount_price" in group){
                  group['discount_price'] = (group['discount_price']*1).toFixed(2)
                }
                else{
                  group['discount_price'] = (0).toFixed(2)
                }
                group.cost_visible = false
                items[loop]['group_options'] = group      
              }        
            }
            category['items'] = items;
            categories[key] = category;
          }
          
          setApprovedPrice((quote.approved_price*1).toFixed(2));
          setDiscount((quote.discount*1).toFixed(2))
          setMemoNote(quote.memo_note)

          var init_quote = {
            user_id: quote.user_id?quote.user_id:null,   
            categories: categories,
            selectedContactUser: quote.contact_user?quote.contact_user:null,            
            selectedContactAddress: quote.contact_address?quote.contact_address:null,
            selectedContactInfo: quote.contact_info?quote.contact_info:null,
            validDate: quote.valid_to?quote.valid_to:null,
            delivery_required: quote.delivery_required?quote.delivery_required:null,
            pickup_instore: quote.pickup_instore?quote.pickup_instore:null,
            collection_id: quote.collection_id?quote.collection_id:null,
            id: quote.id?quote.id:null,
            revision: quote.revision?quote.revision:null,
            memo_note: quote.memo_note,
            totalPrice: quote.price,
            gst: quote.gst,
            status: quote.status,
            order_status: quote.order_status,
            quoteLabel: quote.label,
            clientLabel: quote.client_label,
            defaultBrand: quote.default_brand,
            created_at: quote.created_at,
            wfm_order_no: quote.wfm_order_no
          };
          props.setQuote(init_quote)
        }
        else{          
          var init_quote = {
            id:quote.id,
            user_id: quote.user_id?quote.user_id:null,   
            categories: {},
            memo_note: ''
          };
          props.setQuote(init_quote)
        }
      }
      
      props.setQuoteLoading(false)
    }) 
    setOrderId(id) 
  },[]);

  useEffect(() => {
      console.log('selectedContactUser edit quote   ====>', props.quote)

    if(props.quote.companyLoaded){
      if(!props.quote.productUploaded)
        props.uploadProducts();
    }
  },[props.quote.companyLoaded]);
 
  useEffect(() => {
    if(props.quote.company){
      if(props.quote.company.contacts){
        var newContacts = props.quote.company.contacts
        var newContactId = props.quote.selectedContactUser;
        if(newContactId){
          var newContact = null;
          for(var i = 0; i < newContacts.length; i++){
            if(newContacts[i].id == newContactId){
              newContact = newContacts[i];
              setEmailaddress(newContact.email)
              break;
            }
          }
        }
        else{          
          for(var i = 0; i < newContacts.length; i++){
            if(newContacts[i].primary_set){
              newContact = newContacts[i];
              setEmailaddress(newContact.email)
              break;
            }
          }
          setEmailaddress(null)
        }
      }
    }
  },[props.quote.company, props.quote.selectedContactUser]);

  const renderCategory=()=>{
    const quote = props.quote;
    const categories = quote.categories;
    var elements = [];
    if(categories[0]){
      const category = categories[0]
      elements.push(
        <Category key={0} history={props.history} category={category.category_info} state={category.items} groups={category.groups} updateCategory={props.updateCategory} submitOrder={submitOrder} sendWorkflowmax={sendWorkflowmax} setModal={setModal}/>
      )
    }
    else{
      elements.push(
        <Category key={0} history={props.history} category={null} state={[]} groups={[]} updateCategory={props.updateCategory} submitOrder={submitOrder} sendWorkflowmax={sendWorkflowmax} setModal={setModal}/>
      )
    }

    return elements;
  }
  const sendWorkflowmax=async(orderId, wfm_category)=>{    
    var bodyFormData = new FormData();
    bodyFormData.append('wfm_category',wfm_category?wfm_category:'')
    // if(logoRef.current.files[0])
    //   bodyFormData.append('logo', logoRef.current.files[0]);
    props.setLoading(true);
    axios.post(`/quotes/sendworkflowmax/${orderId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){        
        toast.success("Your order has been saved into workflowmax");
        props.setLoading(false);
      }
      else{
        toast.error(result.data);
        props.setLoading(false);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
      props.setLoading(false);
    })
  }

  const submitOrder=async(e, op)=>{
    const {
      selectedContactUser,
      selectedContactAddress,
      selectedContactInfo,
      custom_address,
      logoImage,
      validDate,
      pickup_instore,
      delivery_required,
      collection_id
    } = props.quote;
    var quote = props.quote;
    var categories = {...quote.categories};
    for(var key in categories){
      var category = {...categories[key]};
      var items = category['items']
      var groups = [];
      for(var loop = 0; loop < items.length; loop++){
        var groupOptions = items[loop]['group_options'];
        groups.push(groupOptions?groupOptions:{});
      }
      category['groups'] = groups;
      categories[key] = category;
    }
    var bodyFormData = new FormData();
    bodyFormData.append('content', JSON.stringify(categories));
    var status;
    var order_status; 
    var successMsg = "success"
    if(op == "save"){
      successMsg = "Your changes have been saved"
    }
    else if(op == "complete_quote"){
      status = "Completed Quote"
      successMsg = "Your quote has been completed"
    }    
    else if(op == "revise"){
      successMsg = "Your quote has been revised"
    }
    else if(op == "accept_order"){
      order_status = "Completed Order"
      successMsg = "Your order has been completed"
    }
    else if(op == "save_order"){
      successMsg = "Your order has been saved"
    }
    else if(op == "request_order"){
      order_status = "Requested Order"
      successMsg = "Your order has been requested"
    }
    if(status)
      bodyFormData.append('status', status);
    if(order_status)
      bodyFormData.append('order_status', order_status);
    bodyFormData.append('discount', discount);
    bodyFormData.append('approved_price', approvedPrice);
    bodyFormData.append('contact_user',selectedContactUser?selectedContactUser:'')
    bodyFormData.append('contact_address',selectedContactAddress?selectedContactAddress:'')
    bodyFormData.append('contact_info',selectedContactInfo?selectedContactInfo:'')
    bodyFormData.append('custom_address',custom_address?custom_address:'')
    bodyFormData.append('valid_to',validDate?validDate:"")
    bodyFormData.append('pickup_instore',pickup_instore?"1":"0")
    bodyFormData.append('collection_id',collection_id?collection_id:'')
    bodyFormData.append('delivery_required',delivery_required?"1":"0")
    bodyFormData.append('updated_at',getDateTime())
    bodyFormData.append('label',quote.quoteLabel?quote.quoteLabel:"")
    bodyFormData.append('client_label',quote.clientLabel?quote.clientLabel:"")
    bodyFormData.append('price',quote.totalPrice?quote.totalPrice:0)    
    bodyFormData.append('gst',quote.gst?quote.gst:0)    
    bodyFormData.append('default_brand',quote.defaultBrand?quote.defaultBrand:"") 
    bodyFormData.append('wfm_order_no',quote.wfm_order_no?quote.wfm_order_no:"") 
    if(logoImage)
      bodyFormData.append('logo', logoImage);

    if(!delivery_required && !pickup_instore){
      toast.error('You must select a delivery preference. Please try again');
      return;
    }
    if((delivery_required || pickup_instore) && !collection_id){
      toast.error('You must select a collection contact. Please try again');
      return;
    }
    
    props.setLoading(true);
    axios.post(`/quotes/edit/${orderId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){   
        props.setLoading(false);     
        if(op != 'save' && op != 'save_order')
          props.history.push("/admin/requests")
        toast.success(successMsg);
      }
      else{
        props.setLoading(false);
        toast.error(result.data?result.data:"Something was wrong. Try again");
      }
    }).catch(err => {
      props.setLoading(false);
      toast.error('Something was wrong. Try again');
    })
  }
  const emailQuote =async()=>{
    var quote = props.quote;
    var job_route ="";
    if(quote.order_status){
      job_route = (quote.order_status.includes("Completed")||quote.order_status.includes("Requested"))?"/myorders/view/":"/myorders/edit/"
    }
    else
      job_route = "/requests/edit/"
    var pdfurl = `${APP_URL}${job_route}${quote.id}`;
    var tmp = ""
    if(emailnote){
      tmp = (""+emailnote).trim();
    }
    if(tmp != ""){
      tmp = tmp+"%0D%0A";
    }

    var body = tmp+"Your quote link: "+pdfurl
    var downloadUrl = "mailto:"
    downloadUrl+=emailaddress;
    downloadUrl+= ("?subject="+`Q${quote['id']} ${(quote['quoteLabel']?quote['quoteLabel']:"")+(quote['revision']?(" - R"+quote['revision']):"")}`)
    downloadUrl+= ("&body="+body)


    const link = document.createElement('a');

    link.href = downloadUrl;

    link.setAttribute('target', "_blank"); //any other extension

    document.body.appendChild(link);

    link.click();

    link.remove();
    setModal(false)

  }

  const emailQuote1 =async()=>{
    var quote = props.quote;
    var categories = {...quote.categories};
    for(var key in categories){
      var category = {...categories[key]};
      var items = category['items']
      var groups = [];
      for(var loop = 0; loop < items.length; loop++){
        var groupOptions = items[loop]['group_options'];
        groups.push(groupOptions?groupOptions:{});
      }
      category['groups'] = groups;
      categories[key] = category;
    }
    var bodyFormData = new FormData();
    bodyFormData.append('content', JSON.stringify(categories));
    // bodyFormData.append('status', "Completed Quote");
    bodyFormData.append('approved_price', approvedPrice);
    bodyFormData.append('discount', discount);
    bodyFormData.append('emailaddress', emailaddress);
    bodyFormData.append('emailnote', emailnote);

    axios.post(`/quotes/quoteemail/${orderId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){        
        // toast.success("The email has been sent successfully");
        var pdfurl = API_URL+result['data'];
        var tmp = ""
        if(emailnote){
          tmp = (""+emailnote).trim();
        }
        if(tmp != ""){
          tmp = tmp+"%0D%0A";
        }
        var body = tmp+"Your quote link: "+pdfurl
        var downloadUrl = "mailto:"
        downloadUrl+=emailaddress;
        downloadUrl+= ("?subject=Your Quote")
        downloadUrl+= ("&body="+body)

  
        const link = document.createElement('a');
    
        link.href = downloadUrl;
    
        link.setAttribute('target', "_blank"); //any other extension
    
        document.body.appendChild(link);
    
        link.click();
    
        link.remove();
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
  }

  const addMemo =async()=>{
    let userId = props.quote.user_id

    if(userId) {
      var bodyFormData = new FormData();
      bodyFormData.append('memo_note', newMemoNote);
      bodyFormData.append('user_to', userId);
      if(props.quote){
        axios.post(`/quotes/addcompanymemo`, bodyFormData).then(res => {
          const result = res.data;
          if(result.status == "success"){        
            getmemo();
            // setNoteModal(false)
          }
          else{
            toast.error(result.data);
          }
        }).catch(err => {
          toast.error('Something was wrong. Try again');
        })
      }
      else{
        toast.error('Quote is empty');
      }
    }
  }

  const uploadfile =async(e)=>{
    let userId = props.quote.user_id

    if(userId) {
      var bodyFormData = new FormData();
      bodyFormData.append('user_to', userId);
      bodyFormData.append('file', e.target.files[0]); 
      if(props.quote){
        axios.post(`/quotes/uploadmemofile`, bodyFormData).then(res => {
          console.log("UPLOAD FROM: Admin/EditQuote.js");
          const result = res.data;
          if(result.status == "success"){        
            getmemo();
            // setNoteModal(false)
          }
          else{
            toast.error(result.data);
          }
        }).catch(err => {
          toast.error('Something was wrong. Try again');
        })
      }
      else{
        toast.error('Quote is empty');
      }
    }
  }
  
  const getMemoCount = (memo)=>{
    if(!memo) return 0
    const  newstrings = memo.split("\n"); 
    return newstrings.length;
  }
  
  const getmemo=()=>{
    let userId = props.quote.user_id

    if(userId) {
      axios.get(`/quotes/getcompanymemo/${userId}`).then(res => {
        if(res.data.status == "success"){
          setMemos(res.data.data)
        }
      }) 
    }
  }
  const removememo = (id)=>{
    axios.get(`/quotes/removememo/${id}`).then(res => {
      if(res.data.status == "success"){
        getmemo()
      }
    }) 
  }

  return (
    <>
      <DemoNavbar />
      <main ref={main}>
        <Container fluid="lg" className="m-auto">
          <Row className="mt-6">
            <Col  md="12">
              <OrderHeader/>              
              {renderCategory()}
              {/* <div style={{marginTop:'60px'}}>
                <div className="order-nav">
                  <div>
                  </div>
                  <div>        */}
                    {/* <Button
                      onClick={()=>setNoteModal(true)}
                      className="btn-icon btn-3 rounded-0" color="primary" type="button">
                      <i style={{fontSize:20}} className="fa fa-commenting-o" aria-hidden="true"></i>
                      <Badge className="badge-white m-0">{getMemoCount(memoNote)}</Badge>
                    </Button>      
                    <Button
                      onClick={(e)=>submitOrder(e, "Pending Quote")} outline
                      className="btn-icon btn-3 rounded-0 border-3" color="primary" type="button">
                      <span className="btn-inner--text">SUBMIT</span>
                    </Button>     
                    <Button
                      onClick={(e)=>submitOrder(e, "Pending Quote")} outline
                      className="btn-icon btn-3 rounded-0 border-3" color="primary" type="button">
                      <span className="btn-inner--text">REVISE</span>
                    </Button>    
                      
                    <Button
                      onClick={(e)=>submitOrder(e, "Completed Quote")} outline
                      className="btn-icon btn-3 rounded-0 border-3" color="primary" type="button">
                      <span className="btn-inner--text">ACCEPT</span>
                    </Button>      
                    <Button
                      onClick={()=>{}} outline
                      className="btn-icon btn-3 rounded-0 border-3" color="primary" type="button">
                      <span className="btn-inner--text">DECLINE</span>
                    </Button>                  */}
                    {/* <Button
                      onClick={()=>setModal(true)} outline
                      className="btn-icon btn-3 rounded-0 border-3" color="primary" type="button">
                      <span className="btn-inner--text">Email Quote</span>
                    </Button>      */}
                    {/* <Button
                      onClick={submitOrder} outline
                      className="btn-icon btn-3 rounded-0 border-3" color="primary" type="button">
                      <span className="btn-inner--text">{(quoteStatus&&quoteStatus.includes("Requested"))?"PENDING REVIEW":"COMPLETE QUOTE"}</span>
                    </Button>
                                    
                    <Button
                      onClick={()=>setModal(true)} outline
                      className="btn-icon btn-3 rounded-0 border-3" color="primary" type="button">
                      <span className="btn-inner--text">Email Quote</span>
                    </Button> */}
                  {/* </div>
                </div>
                <div>
                  <label style={{float:'right', marginTop:10, color:'red'}}>QUOTE VALID FOR 7 DAYS</label>
                </div>
              </div> */}
            </Col>
          </Row>

          <Modal isOpen={modal} toggle={toggle} size="md">
            <ModalHeader toggle={toggle}>
              <h3 className="h4 font-weight-bold mb-0">
                Email Quote
              </h3>
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col  md="12">
                  <FormGroup>
                    <Label><strong>Email address</strong></Label>
                    <Input placeholder="Email" value={emailaddress} onChange={(e)=>setEmailaddress(e.target.value)}/>
                  </FormGroup>
                </Col>
                <Col  md="12">
                  <FormGroup>
                    <Label><strong>Notes</strong></Label>
                    <Input type="textarea" spellcheck="true" placeholder="Note" rows="5" value={emailnote} onChange={(e)=>setEmailnote(e.target.value)}/>
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <div style={{display:'flex', justifyContent:'flex-end', padding:"20px"}}>
              <Button color="primary" onClick={()=>emailQuote()}>Send</Button>{' '}
              <Button color="secondary" onClick={toggle}>Cancel</Button>
            </div>
          </Modal>
          <Modal className="modal-lg conversation-log" isOpen={noteModal} toggle={toggleNote} size="lg">
            <ModalHeader toggle={toggleNote}>
              <h3 className="h4 font-weight-bold mb-0">
              Conversation Log
              </h3>
            </ModalHeader>
            <ModalBody>
                  <FormGroup>
                    <Memo memos = {memos} removememo = {removememo}/>
                  </FormGroup>
                  <FormGroup>
                  {/* <Input type="input" rows="" value={newMemoNote} onChange={(e)=>setNewMemoNote(e.target.value)} placeholder="Type here..."/> */}
                  <Editor
                    initialValue={''}
                    apiKey='tjdmpms7zl95nzbouj8gcxhkk9q122xd7fsce8wjk0hqwn8g'
                    init={{
                      plugins: 'link image code',
                      toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code',
                      content_style: "p { margin: 0 0 3px 0; }",
                    }}
                    onChange={(e)=>setNewMemoNote(e.target.getContent())}
                  />
                  
                  </FormGroup>
                  <div style={{display:'flex', justifyContent:'flex-end', padding:"0 20px"}}>
                    <Button className="" onClick={()=>{document.getElementById(`upload-file`).click();}}  color="primary" type="button">
                      Upload File
                    </Button>
                    <Button color="primary" onClick={()=>addMemo()}> Add </Button> 
                    <Button color="secondary" onClick={toggleNote}> Close </Button>
                  </div>
                  <input type="file" id={`upload-file`} style={{display:'none'}}  onChange={uploadfile}/>
            </ModalBody>            
          </Modal>
        </Container>
      </main>
      <CardsFooter/>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    uploadProducts: ()=>dispatch(uploadProducts()),
    setQuote: quote=>dispatch(setQuote(quote)),
    initQuote:()=>dispatch(initQuote()),
    updateCategory: cat=>dispatch(updateCategory(cat)),
    setLoading:  data=>dispatch(setLoading(data)),
    setQuoteLoading: value=>dispatch(setQuoteLoading(value)),
    setCompanyLoaded: value=>dispatch(setCompanyLoaded(value)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
